module.exports = __webpack_public_path__ + "img/newImg9.fb37009a.jpg";